export default __webpack_public_path__ + "static/media/wazdan.07b4d92d.png";